<p>
    Bouncy Balloons is a carnival themed physics puzzle game. Launch water
    balloons with your slingshot to knockdown the ducks! It is part of a mobile
    web game suite I did in 2016. It features 20 levels with increasing
    mechanics and difficulty.
</p>
